<template>
  <div class="d-flex justify-content-start">
    <inspector-select @inspector-changed="handleInspectorChanged" />
    <el-button type="primary"
               :disabled="!selectedInspector"
               class="px-2 mx-2"
               @click="handleBulkAssign">
      Bulk Assign
    </el-button>
  </div>
</template>

<script>
import InspectorSelect from '@/components/Dashboard/Views/InspectorRouting/InspectorSelect.vue'
import {notifySuccess} from '@/utilities/utils'

export default {
  props: ['inspectionIdsToAssign'],
  components: {InspectorSelect},
  computed: {

    inspectionsToReassignCount() {
      // returns count for both Sets (selectedInspectionIds) or Arrays (selectedQueriedInspectionIds)
      return Array.from(this.inspectionIdsToAssign).length
    }
  },
  data() {
    return {
      selectedInspector: null
    }
  },
  methods: {
    handleInspectorChanged(inspector) {
      this.selectedInspector = inspector
    },
    handleBulkAssign() {
      const payload = {
        assignedInspector: this.selectedInspector,
        inspectionIds: this.inspectionIdsToAssign,
      }
      this.$store.commit('inspectorRouting/bulkReassignInspections', payload)
      // assignmentChanged event triggers map re-render
      this.$eventHub.$emit('assignmentChanged')
      notifySuccess(this, `${this.inspectionsToReassignCount} inspections reassigned to ${this.selectedInspector.label}`)
    },
  }
}
</script>
